const CONFIG = {
    BASE_URL: 'https://api.linkcofab.com',
    DEFAULT_UNIT: 'pouce',
    METRIC_UNIT: 'mm',
    MM_PER_INCH: 25.4,
    DEFAULT_GRADE: '44w',
    DEFAULT_FINITION: 'mf/mf',
    API_TIMEOUT: 10000,
    MAX_RETRIES: 3,
    STORAGE_KEY: 'linkcofab_order_session',
    STORAGE_EXPIRY: 5 * 60 * 1000,
};

// Minimum de commande (avant taxes), appliqué une seule fois sur le total
// de la commande dans updateOrderSummary(). Décision Maxime 2026-10-14.
const MINIMUM_COMMANDE = 70;

let orderItems = [];
let currentEditingIndex = -1;
let isMetric = false;
let materialConfigs = {};
let currentStep = 1;
let currentThicknesses = [];
let isCalculatingDynamicPrice = false;
let dynamicPriceTimeout = null;
let availableThicknessesForMaterial = [];
let availableCombinationsForEpaisseur = {
    grades: [],
    finitions: []
};

let _viewAnimating = false;

function switchView(from, to) {
    const stage = document.getElementById('stage');
    if (!stage || !from || !to || _viewAnimating || from === to) return;
    _viewAnimating = true;
    stage.classList.add('animating');
    const startH = stage.offsetHeight;
    stage.style.height = startH + 'px';
    from.classList.remove('active');
    from.classList.add('is-exiting');
    to.classList.add('active');
    const endH = to.offsetHeight;
    requestAnimationFrame(() => {
        stage.style.height = endH + 'px';
    });

    let done = false;
    const cleanup = () => {
        if (done) return;
        done = true;
        from.classList.remove('is-exiting');
        stage.classList.remove('animating');
        stage.style.height = '';
        _viewAnimating = false;
        stage.removeEventListener('transitionend', onEnd);
    };
    const onEnd = (e) => {
        if (e.target === stage && e.propertyName === 'height') cleanup();
    };
    stage.addEventListener('transitionend', onEnd);
    setTimeout(cleanup, 650);
}

function estScrollTop() {
    const el = document.getElementById('estimateur-content');
    if (el) el.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
    });
}

function showForm() {
    const panel = document.getElementById('estimateurPanel');
    const contact = document.getElementById('form-contact');
    if (contact) contact.classList.add('hidden');
    if (panel) panel.classList.remove('hidden');
    switchView(document.getElementById('results'), document.getElementById('drainForm'));
    estScrollTop();
}

function showList() {
    const panel = document.getElementById('estimateurPanel');
    const contact = document.getElementById('form-contact');
    if (contact) contact.classList.add('hidden');
    if (panel) panel.classList.remove('hidden');
    const results = document.getElementById('results');
    const drainForm = document.getElementById('drainForm');
    if (results && !results.classList.contains('active')) {
        switchView(drainForm, results);
    }
    estScrollTop();
}

function showContactView() {
    const panel = document.getElementById('estimateurPanel');
    const contact = document.getElementById('form-contact');
    if (panel) panel.classList.add('hidden');
    if (contact) contact.classList.remove('hidden');
}

const DOM = {
    elements: {},
    init() {
        const selectors = {
            drainForm: '#drainForm',
            numeroPiece: '#numeroPiece',
            materiel: '#materiel',
            grade: '#grade',
            finition: '#finition',
            unitLabel: '#unitLabel',
            unitToggle: '#unitToggle',
            uniteDeMesure: '#uniteDeMesure',
            epaisseur: '#epaisseur',
            gradeOptions: '#gradeOptions',
            finitionOptions: '#finitionOptions',
            thicknessButtons: '#thicknessButtons',
            errorMessage: '#error-message',
            loading: '#loading',
            orderSummary: '#orderSummary',
            totalPrice: '#totalPrice',
            results: '#results',
            btnContainerResults: '#btn_container_results',
            btnDownloadContainer: '#downloadPDF',
            contactForm: '#contactForm',
            contactContainer: '#form-contact',
            step1: '#step1',
            step2: '#step2',
            stepIndicator: '#stepIndicator',
            itemGrid: '#itemGrid',
            quantite: '#quantite',
            largeur: '#largeur',
            longueur: '#longueur',
            nombreTroue: '#nombreTroue',
            diametreTroue: '#diametreTroue',
            autrePerimetre: '#autrePerimetre',
            nombrePlie: '#nombrePlie',
            dessinFait: '#dessinFait',
            ajouterTrous: '#ajouterTrous',
            trousFields: '#trousFields',
            toggleLabel: '#toggleLabel',
            envoyerFormulaireBtn: '#envoyerFormulaireBtn',
            thicknessError: '#thicknessError',
            prixTotalSpan: '#prixTotal'
        };

        for (const [key, selector] of Object.entries(selectors)) {
            this.elements[key] = document.querySelector(selector);
        }
    },
    get(selector) {
        return this.elements[selector] || document.querySelector(selector);
    }
};

function saveOrderToLocal() {
    const sessionData = {
        timestamp: Date.now(),
        items: orderItems
    };
    localStorage.setItem(CONFIG.STORAGE_KEY, JSON.stringify(sessionData));
}

function loadOrderFromLocal() {
    const saved = localStorage.getItem(CONFIG.STORAGE_KEY);
    if (!saved) return;

    try {
        const sessionData = JSON.parse(saved);
        const now = Date.now();

        if (now - sessionData.timestamp < CONFIG.STORAGE_EXPIRY) {
            orderItems = sessionData.items;
            updateOrderSummary();

            const msgEl = document.getElementById('storage-status-message');
            if (msgEl) msgEl.classList.remove('hidden');
            console.log("Order restored from local storage.");
        } else {
            localStorage.removeItem(CONFIG.STORAGE_KEY);
            console.log("Old session expired and cleared.");
        }
    } catch (e) {
        console.error("Error restoring session:", e);
    }
}

function toggleDisclaimer() {
    const el = document.getElementById('priceDisclaimer');
    const btn = el.querySelector('.toggle-disclaimer');
    const open = el.classList.toggle('expanded');
    btn.textContent = open ? 'Réduire' : 'Voir le détail des délais';
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
}

document.addEventListener('wheel', function() {
    if (document.activeElement.type === 'number') {
        document.activeElement.blur();
    }
});

function normalizeMaterialName(materialName) {
    return materialName
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, '')
        .replace(/[^a-z0-9]/g, '');
}

function getMetaobjectMaterials() {
    const node = document.getElementById('estimateur-material-metaobjects');
    if (!node) return [];

    try {
        const materials = JSON.parse(node.textContent || '[]');
        return Array.isArray(materials) ? materials : [];
    } catch (error) {
        console.warn('Could not parse Shopify material metaobjects:', error);
        return [];
    }
}

function mergeMetaobjectMaterials(configs) {
    getMetaobjectMaterials().forEach(material => {
        const displayName = String(material.name || '').trim();
        const apiName = String(material.apiName || displayName).trim();
        if (!apiName) return;

        const key = normalizeMaterialName(apiName);
        if (configs[key]) {
            configs[key].displayName = displayName || configs[key].displayName || configs[key].originalName;
            configs[key].source = configs[key].source || 'api';
            return;
        }

        configs[key] = {
            originalName: apiName,
            displayName: displayName || apiName,
            source: 'metaobject',
            thicknesses: [],
            types: [],
            grades: [],
            finitions: []
        };
    });

    return configs;
}

function generate4DigitId(existingIds) {
    let id;
    do {
        id = Math.floor(1000 + Math.random() * 9000);
    } while (existingIds.has(id));
    return id;
}

function formatPrice(price) {
    if (typeof price !== 'number' || isNaN(price)) {
        return 'N/A';
    }
    return new Intl.NumberFormat('fr-CA', {
        style: 'currency',
        currency: 'CAD'
    }).format(price);
}

function toggleLoading(show) {
    const loading = DOM.get('loading');
    const errorMessage = DOM.get('errorMessage');

    if (show) {
        errorMessage?.classList.add('hidden');
        loading?.classList.remove('hidden');
    } else {
        loading?.classList.add('hidden');
    }
}

function showError(message) {
    const errorDiv = DOM.get('errorMessage');
    if (errorDiv) {
        errorDiv.textContent = message;
        errorDiv.classList.remove('hidden');
    }
}

function parseDimension(value) {
    const n = parseFloat(String(value ?? '').trim().replace(',', '.'));
    return Number.isFinite(n) ? n : NaN;
}

function roundDim(n, decimals = 4) {
    const f = Math.pow(10, decimals);
    return Math.round(n * f) / f;
}

function isMetricUnit(unit) {
    return unit === CONFIG.METRIC_UNIT || unit === 'mm';
}

function unitLabel(unit) {
    return isMetricUnit(unit) ? 'mm' : 'po';
}

function toInches(value, metric = isMetric) {
    const n = parseDimension(value);
    if (!Number.isFinite(n)) return NaN;
    return metric ? n / CONFIG.MM_PER_INCH : n;
}

function thicknessInchesFromItem(item) {
    const n = parseDimension(item?.epaisseur);
    if (!Number.isFinite(n)) return NaN;
    return isMetricUnit(item.uniteDeMesure) ? n / CONFIG.MM_PER_INCH : n;
}

function convertDisplayedDimensions(toMetric) {
    ['largeur', 'longueur', 'diametreTroue', 'autrePerimetre'].forEach((id) => {
        const el = document.getElementById(id);
        if (!el || el.value === '') return;
        const n = parseDimension(el.value);
        if (!Number.isFinite(n) || n === 0) return;
        el.value = String(roundDim(toMetric ? n * CONFIG.MM_PER_INCH : n / CONFIG.MM_PER_INCH));
    });
}

function applyUnitMode(metric, { convertValues = false } = {}) {
    if (convertValues && metric !== isMetric) {
        convertDisplayedDimensions(metric);
    }
    isMetric = !!metric;
    const seg = document.getElementById('unitSeg');
    if (seg) {
        seg.querySelectorAll('button').forEach((btn) => {
            const btnMetric = btn.getAttribute('data-measure') === 'mm';
            btn.setAttribute('aria-pressed', btnMetric === isMetric ? 'true' : 'false');
        });
    }
    const unite = document.getElementById('uniteDeMesure');
    if (unite) unite.value = isMetric ? CONFIG.METRIC_UNIT : CONFIG.DEFAULT_UNIT;
    document.querySelectorAll('.unit[data-unit]').forEach((u) => {
        u.textContent = isMetric ? '(mm)' : '(po)';
    });
    updateThicknessUnits();
}

function itemToApiUnits(item) {
    const metric = isMetricUnit(item.uniteDeMesure);
    const inchOf = (value) => {
        const n = toInches(value, metric);
        return Number.isFinite(n) ? n : 0;
    };
    return {
        quantite: item.quantite,
        materiel: item.materiel,
        grade: item.grade,
        epaisseur: inchOf(item.epaisseur),
        finition: item.finition,
        uniteDeMesure: CONFIG.DEFAULT_UNIT,
        largeur: inchOf(item.largeur),
        longueur: inchOf(item.longueur),
        nombreTroue: item.nombreTroue || 0,
        diametreTroue: inchOf(item.diametreTroue),
        autrePerimetre: inchOf(item.autrePerimetre),
        nombrePlie: item.nombrePlie || 0,
        dessinFait: item.dessinFait,
        itemIdentifiant: item.numeroPiece || item.itemIdentifiant || 'Pièce non identifiée'
    };
}

function sanitizeDimensionField(input) {
    const raw = input.value;
    let v = raw.replace(/,/g, '.');
    v = v.replace(/[^\d.]/g, '');
    const firstDot = v.indexOf('.');
    if (firstDot !== -1) {
        v = v.slice(0, firstDot + 1) + v.slice(firstDot + 1).replace(/\./g, '');
        const [intPart, decPart = ''] = v.split('.');
        v = intPart + '.' + decPart.slice(0, 4);
    }
    if (v === raw) return;
    const pos = input.selectionStart;
    input.value = v;
    if (typeof pos === 'number') {
        const next = Math.max(0, pos + (v.length - raw.length));
        input.setSelectionRange(next, next);
    }
}

const EXCEPTION_FIELD_MAP = {
    'LARGEUR_EXCEPTION': 'largeur',
    'LONGUEUR_EXCEPTION': 'longueur',
    'PLIE_EXCEPTION': 'nombrePlie',
    'NOMBRE_NEGATIF_EXCEPTION': ['nombreTroue', 'diametreTroue']
};

const API_ERROR_MESSAGES = {
    LARGEUR_EXCEPTION: 'La largeur n’est pas valide pour cette pièce. Vérifiez la dimension saisie.',
    LONGUEUR_EXCEPTION: 'La longueur n’est pas valide pour cette pièce. Vérifiez la dimension saisie.',
    PLIE_EXCEPTION: 'Le nombre de plis n’est pas compatible avec cette pièce. Vérifiez la valeur saisie.',
    NOMBRE_NEGATIF_EXCEPTION: 'Le nombre de trous et le diamètre doivent être des valeurs positives.',
    genericCalc: 'Impossible de calculer le prix pour le moment. Vérifiez vos informations, puis réessayez.',
    timeout: 'La requête a pris trop de temps. Vérifiez votre connexion, puis réessayez.',
    network: 'Connexion impossible. Vérifiez votre réseau, puis réessayez.',
    formMissing: 'Le formulaire n’est pas disponible. Actualisez la page, puis réessayez.'
};

function isTechnicalErrorMessage(message) {
    return /http\s*error|failed to fetch|networkerror|abort|undefined|erreur inconnue|form not found|no thicknesses|status:\s*\d|api error/i.test(String(message || ''));
}

function friendlyApiMessage(exception, rawMessage) {
    if (exception && API_ERROR_MESSAGES[exception]) {
        return API_ERROR_MESSAGES[exception];
    }
    const raw = String(rawMessage || '').trim();
    if (raw && !isTechnicalErrorMessage(raw)) {
        return raw;
    }
    return API_ERROR_MESSAGES.genericCalc;
}

function friendlyNetworkError(error) {
    if (!error) return API_ERROR_MESSAGES.genericCalc;
    const msg = error.message || '';
    if (error.name === 'AbortError' || /timeout|aborted/i.test(msg)) {
        return API_ERROR_MESSAGES.timeout;
    }
    if (/failed to fetch|networkerror|network|load failed/i.test(msg)) {
        return API_ERROR_MESSAGES.network;
    }
    if (/form not found/i.test(msg)) {
        return API_ERROR_MESSAGES.formMissing;
    }
    return friendlyApiMessage(error.exception, msg);
}

function drawingItemLabel(item, index) {
    const name = String(item?.numeroPiece || item?.itemIdentifiant || '').trim();
    if (name && name !== 'Pièce non identifiée') return name;
    return `la pièce ${index + 1}`;
}

function missingDrawingsMessage(items) {
    if (items.length === 1) {
        return `Il manque un dessin technique pour ${items[0]}. Ajoutez-le pour continuer.`;
    }
    return `Il manque un dessin technique pour : ${items.join(', ')}. Ajoutez-les pour continuer.`;
}

function showAPIError(exception, message, showAtBottom = false) {
    clearAPIErrors();

    const friendly = friendlyApiMessage(exception, message);
    const fieldIds = EXCEPTION_FIELD_MAP[exception];

    if (fieldIds) {
        const fields = Array.isArray(fieldIds) ? fieldIds : [fieldIds];

        fields.forEach(fieldId => {
            const field = DOM.get(fieldId);
            if (field) {
                showFieldError(field, friendly);
            }
        });
    }

    if (showAtBottom) {
        showError(friendly);
    }
}

function clearAPIErrors() {
    Object.values(EXCEPTION_FIELD_MAP).flat().forEach(fieldId => {
        const field = DOM.get(fieldId);
        if (field) {
            clearFieldError(field);
        }
    });

    const errorDiv = DOM.get('errorMessage');
    if (errorDiv) {
        errorDiv.classList.add('hidden');
    }
}

async function fetchWithTimeout(url, options = {}) {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), CONFIG.API_TIMEOUT);

    try {
        const response = await fetch(url, {
            ...options,
            signal: controller.signal
        });
        clearTimeout(timeoutId);
        return response;
    } catch (error) {
        clearTimeout(timeoutId);
        throw error;
    }
}

async function retry(fn, maxRetries = CONFIG.MAX_RETRIES) {
    for (let i = 0; i < maxRetries; i++) {
        try {
            return await fn();
        } catch (error) {
            if (i === maxRetries - 1) throw error;
            await new Promise(resolve => setTimeout(resolve, 1000 * (i + 1)));
        }
    }
}

async function buildMaterialConfigs() {
    try {
        const materialsResponse = await retry(() =>
            fetchWithTimeout(`${CONFIG.BASE_URL}/material`)
        );

        if (!materialsResponse.ok) {
            throw new Error(`Failed to fetch materials: ${materialsResponse.status}`);
        }

        const {
            material: materials
        } = await materialsResponse.json();

        const materialPromises = materials.map(async (materialName) => {
            try {
                const [finitionsResponse, gradesResponse] = await Promise.allSettled([
                    fetchWithTimeout(`${CONFIG.BASE_URL}/finition/${encodeURIComponent(materialName)}`),
                    fetchWithTimeout(`${CONFIG.BASE_URL}/grade/${encodeURIComponent(materialName)}`)
                ]);

                let finitions = [];
                if (finitionsResponse.status === 'fulfilled' && finitionsResponse.value.ok) {
                    const finitionsData = await finitionsResponse.value.json();
                    finitions = finitionsData.finition || [];
                } else {
                    console.warn(`Failed to fetch finitions for ${materialName}:`, finitionsResponse.reason);
                }

                let grades = [];
                if (gradesResponse.status === 'fulfilled' && gradesResponse.value.ok) {
                    const gradesData = await gradesResponse.value.json();
                    grades = gradesData.grade || [];
                } else {
                    console.warn(`Failed to fetch grades for ${materialName}:`, gradesResponse.reason);
                }

                const materialKey = normalizeMaterialName(materialName);
                return {
                    key: materialKey,
                    config: {
                        originalName: materialName,
                        thicknesses: [],
                        types: [],
                        grades: grades.map(grade => ({
                            value: grade,
                            title: grade
                        })),
                        finitions: finitions.map(finition => ({
                            value: finition,
                            title: finition
                        }))
                    }
                };
            } catch (error) {
                console.error(`Error processing material ${materialName}:`, error);
                return null;
            }
        });

        const results = await Promise.all(materialPromises);

        results.forEach(result => {
            if (result) {
                materialConfigs[result.key] = result.config;
            }
        });

    } catch (error) {
        console.error('Error building material configs:', error);
    }

    return mergeMetaobjectMaterials(materialConfigs);
}

async function initializeMaterials() {
    const configs = await buildMaterialConfigs();

    if (Object.keys(configs).length > 0) {
        populateMaterialSelect(configs);
        console.log("Materials loaded, awaiting user selection");
    }
    loadOrderFromLocal();
}

function populateMaterialSelect(materialConfigs) {
    const select = DOM.get('materiel');
    if (!select) return;

    const fragment = document.createDocumentFragment();

    const defaultOption = document.createElement("option");
    defaultOption.value = "";
    defaultOption.textContent = "Choisir un matériau";
    defaultOption.disabled = true;
    defaultOption.selected = true;
    fragment.appendChild(defaultOption);

    const materials = Object.values(materialConfigs);
    for (const material of materials) {
        const option = document.createElement("option");
        option.value = material.originalName;
        option.textContent = material.displayName || material.originalName;
        fragment.appendChild(option);
    }

    select.innerHTML = "";
    select.appendChild(fragment);
}

function setSelectPlaceholder(sel, text) {
    if (!sel) return;
    sel.innerHTML = '';
    const o = document.createElement('option');
    o.value = '';
    o.textContent = text;
    o.disabled = true;
    o.selected = true;
    sel.appendChild(o);
    sel.value = '';
    sel.disabled = true;
}

function clearMaterialOptions() {
    setSelectPlaceholder(DOM.get('grade'), "Choisissez d'abord un matériau");
    setSelectPlaceholder(DOM.get('finition'), "Choisissez d'abord un matériau");

    const epaisseurInput = document.getElementById('epaisseur');
    if (epaisseurInput) {
        delete epaisseurInput.dataset.currentMaterial;
        delete epaisseurInput.dataset.currentGrade;
        delete epaisseurInput.dataset.currentFinition;
    }
    resetThicknessSelection();
}

function updateMaterialOptions(material) {
    const config = material;
    if (!config) return;

    setSelectPlaceholder(DOM.get('grade'), "Choisissez d'abord une épaisseur");
    setSelectPlaceholder(DOM.get('finition'), "Choisissez d'abord une épaisseur");

    window.currentMaterialConfig = config;

    fetchThicknessesForMaterial();
}

async function fetchThicknessesForMaterial() {
    const material = document.getElementById('materiel')?.value;
    if (!material) return;

    const thicknessContainer = document.getElementById('thicknessButtons');
    const errorDiv = document.getElementById('thicknessError');

    thicknessContainer.innerHTML = '<div class="loading-spinner"></div> <span style="margin-left: 10px;">Chargement des épaisseurs...</span>';
    errorDiv.style.display = 'none';

    try {
        const response = await fetchWithTimeout(`${CONFIG.BASE_URL}/epaisseur/${encodeURIComponent(material)}`);

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        const thicknesses = data.epaisseur || [];

        if (!Array.isArray(thicknesses) || thicknesses.length === 0) {
            showThicknessError('empty');
            return;
        }

        availableThicknessesForMaterial = thicknesses;
        currentThicknesses = thicknesses;
        renderThicknessButtons(thicknesses);

    } catch (error) {
        console.error('Error fetching thicknesses:', error);
        showThicknessError('load');
    }
}

async function fetchAvailableCombinationsForEpaisseur(material, epaisseur) {
    try {
        const response = await fetchWithTimeout(`${CONFIG.BASE_URL}/finitionGrade`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                material: material,
                epaisseur: parseFloat(epaisseur)
            })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        availableCombinationsForEpaisseur = {
            grades: data.grades || [],
            finitions: data.finitions || []
        };

        populateGradeFinitionOptions();

        updateGradeFinitionAvailability();

    } catch (error) {
        console.error('Error fetching available combinations:', error);
        availableCombinationsForEpaisseur = {
            grades: [],
            finitions: []
        };

        populateGradeFinitionOptions();
        updateGradeFinitionAvailability();
    }
}

function fillSelect(sel, items, placeholder) {
    if (!sel) return;
    const previous = sel.value || '';
    sel.innerHTML = '';
    const ph = document.createElement('option');
    ph.value = '';
    ph.textContent = placeholder;
    ph.disabled = true;
    sel.appendChild(ph);

    let matched = false;
    (items || []).forEach((it) => {
        const o = document.createElement('option');
        o.value = it.value;
        o.textContent = it.title;
        if (it.value === previous) {
            o.selected = true;
            matched = true;
        }
        sel.appendChild(o);
    });

    sel.disabled = false;
    if (!matched) {
        ph.selected = true;
        sel.value = '';
    }
}

function populateGradeFinitionOptions() {
    const config = window.currentMaterialConfig;
    if (!config) return;

    if (config.grades?.length) {
        fillSelect(DOM.get('grade'), config.grades, 'Choisir un grade');
    }
    if (config.finitions?.length) {
        fillSelect(DOM.get('finition'), config.finitions, 'Choisir une finition');
    }
}

function applySelectAvailability(sel, available) {
    if (!sel) return;
    Array.from(sel.options).forEach(opt => {
        if (!opt.value) return;
        const ok = available.length === 0 || available.includes(opt.value);
        opt.disabled = !ok;
        if (!ok && sel.value === opt.value) {
            sel.value = '';
        }
    });
}

function updateGradeFinitionAvailability() {
    applySelectAvailability(DOM.get('grade'), availableCombinationsForEpaisseur.grades);
    applySelectAvailability(DOM.get('finition'), availableCombinationsForEpaisseur.finitions);
}

function renderThicknessButtons(thicknesses) {
    const thicknessContainer = document.getElementById('thicknessButtons');
    const hiddenInput = document.getElementById('epaisseur');

    thicknessContainer.innerHTML = '';

    hiddenInput.value = '';

    thicknesses.forEach(thickness => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'thickness-button';

        const inchValue = parseFloat(thickness);
        const displayValue = isMetric
            ? `${roundDim(inchValue * CONFIG.MM_PER_INCH, 2)} mm`
            : `${thickness}"`;

        button.dataset.value = String(inchValue);
        button.textContent = displayValue;

        button.addEventListener('click', async function() {
            document.querySelectorAll('.thickness-button').forEach(btn => {
                btn.classList.remove('selected');
            });

            this.classList.add('selected');

            const inchThickness = parseFloat(this.dataset.value);
            hiddenInput.value = String(inchThickness);

            const gradeInput = DOM.get('grade');
            const finitionInput = DOM.get('finition');
            if (gradeInput) gradeInput.value = '';
            if (finitionInput) finitionInput.value = '';

            const material = document.getElementById('materiel')?.value;
            if (material) {
                await fetchAvailableCombinationsForEpaisseur(material, inchThickness);
            }

            hiddenInput.dispatchEvent(new Event('change'));
            calculateDynamicPrice();
        });

        thicknessContainer.appendChild(button);
        calculateDynamicPrice();
    });
}

function showThicknessError(kind = 'load') {
    const thicknessContainer = document.getElementById('thicknessButtons');
    const errorDiv = document.getElementById('thicknessError');

    if (kind === 'empty') {
        thicknessContainer.innerHTML = '<div class="thick-placeholder">Aucune épaisseur n’est disponible pour ce matériau.</div>';
        if (errorDiv) errorDiv.style.display = 'none';
        return;
    }

    if (thicknessContainer) thicknessContainer.innerHTML = '';
    if (errorDiv) {
        errorDiv.textContent = 'Impossible de charger les épaisseurs pour ce matériau. Réessayez ou choisissez un autre matériau.';
        errorDiv.style.display = 'block';
    }
}

function resetThicknessSelection() {
    const thicknessContainer = document.getElementById('thicknessButtons');
    const errorDiv = document.getElementById('thicknessError');
    const hiddenInput = document.getElementById('epaisseur');

    thicknessContainer.innerHTML = `<div id="thicknessPlaceholder" class="thick-placeholder">Choisissez d'abord un matériau</div>`;
    errorDiv.style.display = 'none';
    hiddenInput.value = '';
    currentThicknesses = [];
    availableThicknessesForMaterial = [];
    availableCombinationsForEpaisseur = {
        grades: [],
        finitions: []
    };

    setSelectPlaceholder(DOM.get('grade'), "Choisissez d'abord un matériau");
    setSelectPlaceholder(DOM.get('finition'), "Choisissez d'abord un matériau");
}

function updateThicknessUnits() {
    if (currentThicknesses.length > 0) {
        const currentButton = document.querySelector('.thickness-button.selected');
        const selectedInch = currentButton ? parseFloat(currentButton.dataset.value) : null;

        renderThicknessButtons(currentThicknesses);

        if (Number.isFinite(selectedInch)) {
            document.querySelectorAll('.thickness-button').forEach(button => {
                if (Math.abs(parseFloat(button.dataset.value) - selectedInch) < 0.0001) {
                    button.classList.add('selected');
                    document.getElementById('epaisseur').value = button.dataset.value;
                }
            });
        }
    }
}

async function calculatePrice() {
    toggleLoading(true);

    try {
        const form = DOM.get('drainForm');
        if (!form) throw new Error('Form not found');

        const formData = new FormData(form);
        const largeurDisplay = parseDimension(formData.get('largeur'));
        const longueurDisplay = parseDimension(formData.get('longueur'));
        const inchThickness = Number(formData.get('epaisseur'));

        const apiPayloadItem = {
            "quantite": Number(formData.get('quantite')),
            "materiel": formData.get('materiel'),
            "grade": DOM.get('grade')?.value || '',
            "epaisseur": inchThickness,
            "finition": DOM.get('finition')?.value || '',
            "uniteDeMesure": CONFIG.DEFAULT_UNIT,
            "largeur": toInches(formData.get('largeur')),
            "longueur": toInches(formData.get('longueur')),
            "nombreTroue": Number(formData.get('nombreTroue')) || 0,
            "diametreTroue": toInches(formData.get('diametreTroue')) || 0,
            "autrePerimetre": toInches(formData.get('autrePerimetre')) || 0,
            "nombrePlie": Number(formData.get('nombrePlie')) || 0,
            "dessinFait": formData.get('dessinFait') === 'on',
            "itemIdentifiant": formData.get('numeroPiece') || 'Pièce non identifiée'
        };

        console.log('📤 SENT TO API:', apiPayloadItem);

        const payload = {
            items: [apiPayloadItem]
        };
        const response = await retry(() =>
            fetchWithTimeout(`${CONFIG.BASE_URL}/commande/estimation`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload),
            })
        );

        if (!response.ok) {
            let errorData;

            try {
                errorData = await response.json();
            } catch {
                throw new Error(`HTTP error ${response.status}`);
            }

            const apiError = new Error(errorData.message || "Erreur inconnue");
            apiError.status = response.status;
            apiError.exception = errorData.exception;

            if (errorData.exception) {
                showAPIError(errorData.exception, errorData.message, true);
            }

            throw apiError;
        }

        const data = await response.json();
        console.log("📥 API RESPONSE:", data);

        toggleLoading(false);

        const result = returnPerPlaque(data);
        const existingIds = new Set(orderItems.map(item => item.id));

        const storageItem = {
            "quantite": apiPayloadItem.quantite,
            "materiel": apiPayloadItem.materiel,
            "grade": apiPayloadItem.grade,
            "epaisseur": isMetric ? roundDim(inchThickness * CONFIG.MM_PER_INCH, 2) : inchThickness,
            "finition": apiPayloadItem.finition,
            "uniteDeMesure": isMetric ? CONFIG.METRIC_UNIT : CONFIG.DEFAULT_UNIT,
            "largeur": largeurDisplay,
            "longueur": longueurDisplay,
            "nombreTroue": apiPayloadItem.nombreTroue,
            "diametreTroue": parseDimension(formData.get('diametreTroue')) || 0,
            "autrePerimetre": parseDimension(formData.get('autrePerimetre')) || 0,
            "nombrePlie": apiPayloadItem.nombrePlie,
            "dessinFait": apiPayloadItem.dessinFait,
            "itemIdentifiant": apiPayloadItem.itemIdentifiant,

            "price": result.price,
            "poids": result.poids,
            "numeroDePiece": result.numeroDePiece,
            "numeroPiece": formData.get('numeroPiece') || '',
            "id": generate4DigitId(existingIds)
        };

        console.log('💾 STORED ITEM:', storageItem);

        if (currentEditingIndex >= 0) {
            orderItems[currentEditingIndex] = storageItem;
            currentEditingIndex = -1;
        } else {
            orderItems.push(storageItem);
        }

        updateOrderSummary();
        showList();

    } catch (error) {
        toggleLoading(false);

        if (!error.exception) {
            showError(friendlyNetworkError(error));
        }
        console.error("API call failed:", error);
    }
}

function returnPerPlaque(data) {
    const pricePerPlaque = formatPrice(data.Items?.[0] || 0);
    const poidsValue = parseFloat(data.Poids) || 0;
    const poidsPerPlaque = parseFloat(poidsValue.toFixed(2));
    const numeroDePiece = data.NumeroDePiece || '';

    return {
        price: pricePerPlaque,
        poids: poidsPerPlaque,
        numeroDePiece: numeroDePiece
    };
}

function updateOrderSummary() {
    const summaryDiv = DOM.get('orderSummary');
    const totalPriceSpan = DOM.get('totalPrice');
    const btnContainer = DOM.get('btnContainerResults');
    const btnDownload = DOM.get('btnDownloadContainer');
    const emptyState = document.getElementById('emptyState');
    const restartLink = document.getElementById('restartLink');

    if (orderItems.length === 0) {
        if (summaryDiv) {
            summaryDiv.innerHTML = '';
            summaryDiv.hidden = true;
        }
        if (emptyState) emptyState.hidden = false;
        if (totalPriceSpan) totalPriceSpan.innerHTML = '0.00$';
        if (btnDownload) btnDownload.classList.add('hidden');
        if (restartLink) restartLink.classList.add('hidden');
        return;
    }

    if (emptyState) emptyState.hidden = true;
    if (summaryDiv) summaryDiv.hidden = false;
    if (btnDownload) btnDownload.classList.remove('hidden');
    if (restartLink) restartLink.classList.remove('hidden');

    let totalPrice = orderItems.reduce((sum, item) => {
        const itemPrice = parseFloat((item.price || '').toString().replace(',', '.')) || 0;
        return sum + itemPrice;
    }, 0);

    let minimumApplique = false;
    if (totalPrice > 0 && totalPrice < MINIMUM_COMMANDE) {
        totalPrice = MINIMUM_COMMANDE;
        minimumApplique = true;
    }

    const summaryHTML = orderItems.map((item, index) => `
        <div class="plaque-card fade-in">
            <button class="close-btn" onclick="removeItem(${index})">×</button>
                         <div class="plaque-header">
                 <span class="plaque-title">${item.numeroPiece ? `Pièce ${item.numeroPiece}` : `Pièce ${index + 1}`}</span>
                 <button class="modifier-btn" onclick="editItem(${index}, false)">Modifier</button>
                 <button class="modifier-btn modifier-btn-secondary" onclick="duplicate(${index})">Dupliquer</button>
             </div>
            <div class="specs">
                <div class="spec-item">
                    <span class="spec-label">Quantité :</span>
                    <span class="spec-value">${item.quantite}</span>
                </div>
                <div class="spec-item">
                    <span class="spec-label">Matériel :</span>
                    <span class="spec-value">${item.materiel}</span>
                </div>
                <div class="spec-item">
                    <span class="spec-label">Grade :</span>
                    <span class="spec-value">${item.grade}</span>
                </div>
                <div class="spec-item">
                    <span class="spec-label">Finition :</span>
                    <span class="spec-value">${item.finition}</span>
                </div>
                <div class="spec-item">
                    <span class="spec-label">Dimensions :</span>
                    <span class="spec-value">${item.largeur} × ${item.longueur} ${unitLabel(item.uniteDeMesure)}</span>
                </div>
                <div class="spec-item">
                    <span class="spec-label">Épaisseur :</span>
                    <span class="spec-value">${item.epaisseur} ${unitLabel(item.uniteDeMesure)}</span>
                </div>
                <div class="spec-item">
                    <span class="spec-label">Nb. de trous :</span>
                    <span class="spec-value">${item.nombreTroue}</span>
                </div>
                <div class="spec-item">
                    <span class="spec-label">Diamètre des trous :</span>
                    <span class="spec-value">${item.diametreTroue}</span>
                </div>
                <div class="spec-item">
                    <span class="spec-label">Longueur totale de découpe supplémentaire :</span>
                    <span class="spec-value">${item.autrePerimetre}</span>
                </div>
                <div class="spec-item">
                    <span class="spec-label">Nb. de plis :</span>
                    <span class="spec-value">${item.nombrePlie}</span>
                </div>
                <div class="spec-item">
                    <span class="spec-label">Dessin :</span>
                    <span class="spec-value">${item.dessinFait ? 'Oui' : 'Non'}</span>
                </div>
                <div class="spec-item">
                    <span class="spec-label">Unité de mesure :</span>
                    <span class="spec-value">${unitLabel(item.uniteDeMesure)}</span>
                </div>
                <div class="spec-item">
                    <span class="spec-label">Poids par item :</span>
                    <span class="spec-value">${item.poids} lb</span>
                </div>
                <div class="spec-item">
                    <span class="spec-label">Poids total :</span>
                    <span class="spec-value">${item.poids * item.quantite} lb</span>
                </div>
                 ${parseInt(item.quantite) !== 1 ? `
                <div class="spec-item">
                    <span class="spec-label">Prix unitaire :</span>
                    <span class="spec-value">${(parseFloat(item.price.replace(/[^\d,.-]/g, '').replace(',', '.')) / item.quantite).toFixed(2)} $</span>
                </div>
            ` : ''}
                <div class="priceContainer">Prix : <span class="pricePerItem">${item.price}</span></div>
            </div>
        </div>
    `).join('');

    const minimumNoteHTML = minimumApplique ? `
        <div style="margin-top:10px;font-weight:600;">Minimum de commande de ${MINIMUM_COMMANDE} $ appliqué.</div>
    ` : '';
    if (summaryDiv) summaryDiv.innerHTML = summaryHTML + minimumNoteHTML;
    if (totalPriceSpan) totalPriceSpan.textContent = formatPrice(totalPrice);
    saveOrderToLocal();
}

function removeItem(index) {
    if (confirm('Voulez-vous vraiment supprimer cet item ?')) {
        orderItems.splice(index, 1);
        updateOrderSummary();
    }
}

async function editItem(index, isSecondStep) {
    const item = orderItems[index];
    if (!item) return;
    const numeroPieceField = DOM.get('numeroPiece');

    const formElements = {
        quantite: DOM.get('quantite'),
        materiel: DOM.get('materiel'),
        grade: DOM.get('grade'),
        finition: DOM.get('finition'),
        uniteDeMesure: DOM.get('uniteDeMesure'),
        largeur: DOM.get('largeur'),
        longueur: DOM.get('longueur'),
        nombreTroue: DOM.get('nombreTroue'),
        diametreTroue: DOM.get('diametreTroue'),
        autrePerimetre: DOM.get('autrePerimetre'),
        nombrePlie: DOM.get('nombrePlie'),
        dessinFait: DOM.get('dessinFait')
    };

    if (numeroPieceField) numeroPieceField.value = item.numeroPiece || '';
    if (formElements.quantite) formElements.quantite.value = item.quantite;
    if (formElements.materiel) formElements.materiel.value = item.materiel;

    applyUnitMode(isMetricUnit(item.uniteDeMesure));

    const inchThickness = thicknessInchesFromItem(item);
    const cleanValue = normalizeMaterialName(item.materiel);
    const selectedMaterialConfig = materialConfigs[cleanValue];

    if (selectedMaterialConfig) {
        updateMaterialOptions(selectedMaterialConfig);

        setTimeout(async () => {
            const thicknessButtons = document.querySelectorAll('.thickness-button');
            thicknessButtons.forEach(btn => {
                if (Math.abs(parseFloat(btn.dataset.value) - inchThickness) < 0.001) {
                    btn.classList.add('selected');
                    const epaisseurInput = DOM.get('epaisseur');
                    if (epaisseurInput) epaisseurInput.value = btn.dataset.value;
                }
            });

            await fetchAvailableCombinationsForEpaisseur(item.materiel, inchThickness);

            setTimeout(() => {
                if (formElements.grade) formElements.grade.value = item.grade;
                if (formElements.finition) formElements.finition.value = item.finition;

                const gradeButtons = document.querySelectorAll('[data-grade]');
                gradeButtons.forEach(btn => {
                    if (btn.dataset.grade === item.grade) {
                        btn.classList.add('selected');
                    } else {
                        btn.classList.remove('selected');
                    }
                });

                const finitionButtons = document.querySelectorAll('[data-finition]');
                finitionButtons.forEach(btn => {
                    if (btn.dataset.finition === item.finition) {
                        btn.classList.add('selected');
                    } else {
                        btn.classList.remove('selected');
                    }
                });
            }, 100);
        }, 100);
    }

    if (formElements.uniteDeMesure) formElements.uniteDeMesure.value = item.uniteDeMesure;
    if (formElements.largeur) formElements.largeur.value = item.largeur;
    if (formElements.longueur) formElements.longueur.value = item.longueur;
    if (formElements.nombreTroue) formElements.nombreTroue.value = item.nombreTroue;
    if (formElements.diametreTroue) formElements.diametreTroue.value = item.diametreTroue;
    if (formElements.autrePerimetre) formElements.autrePerimetre.value = item.autrePerimetre;
    if (formElements.nombrePlie) formElements.nombrePlie.value = item.nombrePlie;
    if (formElements.dessinFait) formElements.dessinFait.checked = item.dessinFait || false;

    setHoles(Number(item.nombreTroue) > 0 || Number(item.diametreTroue) > 0);
    if (formElements.nombreTroue) formElements.nombreTroue.value = item.nombreTroue;
    if (formElements.diametreTroue) formElements.diametreTroue.value = item.diametreTroue;

    currentEditingIndex = index;
    const btn = DOM.get('prixTotalSpan');
    showForm();
    if (btn) btn.textContent = "Modifier la pièce";
}

function duplicate(index) {
    const itemToDuplicate = orderItems[index];
    if (!itemToDuplicate) return;

    const newItem = {
        ...itemToDuplicate,
        id: generate4DigitId(new Set(orderItems.map(item => item.id)))
    };
    orderItems.push(newItem);
    updateOrderSummary();
}

function recalculate() {
    if (confirm('Voulez-vous vraiment supprimer cette estimation et recommencer ?')) {
        DOM.get('errorMessage')?.classList.add('hidden');
        DOM.get('loading')?.classList.add('hidden');

        orderItems = [];
        currentEditingIndex = -1;

        const drainForm = DOM.get('drainForm');
        if (drainForm && typeof drainForm.reset === 'function') {
            drainForm.reset();
        }

        const materialSelect = DOM.get('materiel');
        if (materialSelect?.options.length > 0) {
            materialSelect.selectedIndex = 0;
        }
        localStorage.removeItem(CONFIG.STORAGE_KEY);
        const msgEl = document.getElementById('storage-status-message');
        if (msgEl) msgEl.classList.add('hidden');
        clearMaterialOptions();
        updateOrderSummary();
    }
}

function ajouterPlaque() {
    const drainForm = DOM.get('drainForm');
    if (drainForm && typeof drainForm.reset === 'function') {
        drainForm.reset();
    }

    const btn = DOM.get('prixTotalSpan');
    if (btn) btn.textContent = "Ajouter cette pièce";

    const materialSelect = DOM.get('materiel');
    if (materialSelect?.options.length > 0) {
        materialSelect.selectedIndex = 0;
    }
    const epaisseurInput = document.getElementById('epaisseur');
    if (epaisseurInput) {
        delete epaisseurInput.dataset.currentMaterial;
        delete epaisseurInput.dataset.currentGrade;
        delete epaisseurInput.dataset.currentFinition;
    }
    clearMaterialOptions();
    resetCustomControls();
    showForm();
}

function sendQuote() {
    if (!orderItems.length) return;
    showContactView();
    console.log(orderItems);
    initializeForm();
    document.getElementById('form-contact')?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
    });
}

function setHoles(on) {
    const chk = document.getElementById('ajouterTrous');
    if (chk) chk.checked = on;
    document.querySelectorAll('input[name="holesToggle"]').forEach((r) => {
        r.checked = (r.value === (on ? 'on' : 'off'));
    });
    document.getElementById('trousFields')?.classList.toggle('open', on);
    const holesState = document.getElementById('holesState');
    if (holesState) holesState.textContent = on ? 'Oui' : 'Non';
    if (!on) {
        const nombreTroueField = document.getElementById('nombreTroue');
        const diametreTroueField = document.getElementById('diametreTroue');
        if (nombreTroueField) nombreTroueField.value = 0;
        if (diametreTroueField) diametreTroueField.value = 0;
    }
}

function resetCustomControls() {
    applyUnitMode(false);

    setHoles(false);

    const prix = document.getElementById('prixTotal');
    if (prix) prix.textContent = currentEditingIndex >= 0 ? 'Modifier la pièce' : 'Calculer le prix';
    document.querySelector('.prixParPiece')?.remove();
}

function initializeForm() {
    currentStep = 1;
    DOM.get('step1')?.classList.add('active');
    DOM.get('step2')?.classList.remove('active');
    updateStepIndicator();
    updateContactFormTitle();
    generateItemGrid();

    const contactForm = DOM.get('contactForm');
    if (contactForm && typeof contactForm.reset === 'function') {
        contactForm.reset();
    }

    DOM.get('errorMessage')?.classList.add('hidden');
}

function retour() {
    clearGrid();
    showList();
}

function showMainScreenAndReset() {
    const drainForm = DOM.get('drainForm');

    if (drainForm && typeof drainForm.reset === 'function') {
        drainForm.reset();
    }

    const materialSelect = DOM.get('materiel');
    if (materialSelect?.options.length > 0) {
        materialSelect.selectedIndex = 0;
    }

    currentEditingIndex = -1;
    clearMaterialOptions();
    resetCustomControls();
    showList();
    const btn = DOM.get('prixTotalSpan');
    if (btn) btn.textContent = "Calculer le prix";
}

function nextStep() {
    if (currentStep < 2) {
        if (currentStep === 1) {
            const missingFiles = [];
            orderItems.forEach((item, index) => {
                if (item.dessinFait) {
                    const fileInput = document.getElementById(`file-${index}`);
                    if (!fileInput || !fileInput.files || fileInput.files.length === 0) {
                        missingFiles.push(drawingItemLabel(item, index));
                    }
                }
            });

            if (missingFiles.length > 0) {
                const errorMessage = DOM.get('errorMessage');
                if (errorMessage) {
                    errorMessage.textContent = missingDrawingsMessage(missingFiles);
                    errorMessage.classList.remove('hidden');
                    errorMessage.scrollIntoView({
                        behavior: 'smooth'
                    });
                }
                return;
            }
        }

        const errorMessage = DOM.get('errorMessage');
        if (errorMessage) {
            errorMessage.classList.add('hidden');
        }

        DOM.get(`step${currentStep}`)?.classList.remove('active');
        currentStep++;
        DOM.get(`step${currentStep}`)?.classList.add('active');
        updateStepIndicator();
        updateContactFormTitle();
        resetContactFormView();
    }
}

function previousStep() {
    if (currentStep > 1) {
        DOM.get(`step${currentStep}`)?.classList.remove('active');
        currentStep--;
        DOM.get(`step${currentStep}`)?.classList.add('active');
        updateStepIndicator();
        updateContactFormTitle();
        resetContactFormView();

        if (currentStep === 1) {
            generateItemGrid();
        }
    }
}

function resetContactFormView() {
    document.getElementById('form-contact')?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
    });
}

function updateStepIndicator() {
    const indicator = DOM.get('stepIndicator');
    if (indicator) {
        indicator.textContent = `Étape ${currentStep} de 2`;
    }
}

function updateContactFormTitle() {
    const titleElement = document.getElementById('contactFormTitle');
    if (titleElement) {
        titleElement.textContent = currentStep === 1 ? 'Ajouter des fichiers' : 'Envoyer ma demande';
    }
}

function setupAllEventListeners() {
    const dynamicPriceFields = [
        'quantite', 'largeur', 'longueur', 'nombreTroue', 'diametreTroue', 'autrePerimetre', 'nombrePlie'
    ];

    dynamicPriceFields.forEach(fieldId => {
        const field = DOM.get(fieldId);
        if (field) {
            field.addEventListener('input', calculateDynamicPrice);
            field.addEventListener('change', calculateDynamicPrice);
            field.addEventListener('blur', calculateDynamicPrice);
        }
    });

    const materielSelect = DOM.get('materiel');
    if (materielSelect) {
        materielSelect.addEventListener('change', calculateDynamicPrice);
    }

    const dessinFaitCheckbox = DOM.get('dessinFait');
    if (dessinFaitCheckbox) {
        dessinFaitCheckbox.addEventListener('change', calculateDynamicPrice);
    }

    document.addEventListener('click', function(e) {
        const gradeBtn = e.target.closest('[data-grade]');
        const finitionBtn = e.target.closest('[data-finition]');

        if (gradeBtn) {
            document.querySelectorAll('[data-grade]').forEach(b => b.classList.remove('selected'));
            gradeBtn.classList.add('selected');
            const gradeInput = DOM.get('grade');
            if (gradeInput) gradeInput.value = gradeBtn.dataset.grade;
            calculateDynamicPrice();
        }

        if (finitionBtn) {
            document.querySelectorAll('[data-finition]').forEach(b => b.classList.remove('selected'));
            finitionBtn.classList.add('selected');
            const finitionInput = DOM.get('finition');
            if (finitionInput) finitionInput.value = finitionBtn.dataset.finition;
            calculateDynamicPrice();
        }
    });

    ['grade', 'finition'].forEach(id => {
        const el = DOM.get(id);
        if (el) el.addEventListener('change', calculateDynamicPrice);
    });

    const unitSeg = document.getElementById('unitSeg');
    if (unitSeg) {
        unitSeg.addEventListener('click', function(e) {
            const btn = e.target.closest('button');
            if (!btn) return;
            const nextMetric = btn.getAttribute('data-measure') === 'mm' || btn.textContent.includes('Métrique');
            if (nextMetric === isMetric) return;
            applyUnitMode(nextMetric, { convertValues: true });
            calculateDynamicPrice();
        });
    }

    document.querySelectorAll('input[name="holesToggle"]').forEach((radio) => {
        radio.addEventListener('change', () => {
            setHoles(radio.value === 'on');
            calculateDynamicPrice();
        });
    });

    document.addEventListener('click', function(e) {
        const step = e.target.closest('.num-step');
        if (!step) return;
        const wrap = step.closest('.num');
        const input = wrap && wrap.querySelector('input');
        if (!input) return;
        const min = input.min !== '' ? parseFloat(input.min) : -Infinity;
        const stepSize = parseFloat(input.step) || 1;
        let v = parseFloat(input.value);
        if (isNaN(v)) v = 0;
        v += step.dataset.dir === 'up' ? stepSize : -stepSize;
        if (v < min) v = min;
        input.value = String(v);
        input.dispatchEvent(new Event('input', {
            bubbles: true
        }));
        input.dispatchEvent(new Event('change', {
            bubbles: true
        }));
    });

    document.addEventListener('change', function(event) {
        if (event.target.type === 'file') {
            handleFileUpload(event);
        }
        if (event.target.id === 'epaisseur') {
            calculateDynamicPrice();
        }
    });

    document.addEventListener('click', function(event) {
        if (event.target.classList.contains('thickness-button')) {
            setTimeout(() => {
                calculateDynamicPrice();
            }, 0);
        }
    });
}

function generateItemGrid() {
    const gridContainer = DOM.get('itemGrid');
    if (!gridContainer) return;

    gridContainer.innerHTML = '';

    const fragment = document.createDocumentFragment();

    orderItems.forEach((item, index) => {
        const itemCard = document.createElement('div');
        itemCard.className = 'item-card';

        const requiredIndicator = item.dessinFait ? '<span style="color: red;">*</span>' : '';
        const requiredAttribute = item.dessinFait ? 'required' : '';
        const requiredClass = item.dessinFait ? 'file-required' : '';

        itemCard.innerHTML = `
              <div class="item-header">
              <div class="item-number-modifier">
               <div class="item-number">${item.numeroPiece ? `Article #${item.numeroPiece}` : `Article #${index + 1}`}</div>
               <button class="modifier-btn" onclick="editItem(${index},true)">Modifier</button>
     </div>
                 <div class="item-price">${item.price}</div>

             </div>

            <div class="item-details">
                <div class="detail-row">
                    <span class="detail-label">Quantité:</span>
                    <span class="detail-value">${item.quantite}</span>
                </div>
                <div class="detail-row">
                    <span class="detail-label">Matériel:</span>
                    <span class="detail-value">${item.materiel}</span>
                </div>
                <div class="detail-row">
                    <span class="detail-label">Grade:</span>
                    <span class="detail-value">${item.grade}</span>
                </div>
                <div class="detail-row">
                    <span class="detail-label">Finition:</span>
                    <span class="detail-value">${item.finition}</span>
                </div>
                <div class="detail-row">
                    <span class="detail-label">Dimensions:</span>
                    <span class="detail-value">${item.largeur} x ${item.longueur} ${unitLabel(item.uniteDeMesure)}</span>
                </div>
                <div class="detail-row">
                    <span class="detail-label">Dessin technique:</span>
                    <span class="detail-value">${item.dessinFait ? 'Oui' : 'Non'}</span>
                </div>
            </div>

            <div class="file-upload-section ${requiredClass}">
                <label class="file-upload-label" for="file-${index}">Téléverser le dessin (max 3 fichiers) : ${requiredIndicator}</label>
                <input
                type="file"
                id="file-${index}"
                name="filename-${index}"
                class="file-input"
                accept=".dwg,.dxf,.pdf,.png,.jpg,.jpeg,.dgn,.svg,.step,.stp,.iges,.igs"
                multiple
                ${requiredAttribute}
                >
                <div class="file-list" id="file-list-${index}"></div>
            </div>`;

        fragment.appendChild(itemCard);
    });

    gridContainer.appendChild(fragment);

    validateAllFiles();
}

function clearGrid() {
    const gridContainer = DOM.get('itemGrid');
    if (gridContainer) {
        gridContainer.innerHTML = "";
    }
}

function handleFileUpload(event) {
    const fileInput = event.target;
    const files = fileInput.files;
    const itemIndex = fileInput.id.replace('file-', '');
    const fileList = document.getElementById(`file-list-${itemIndex}`);

    if (!files || files.length === 0) {
        const itemCard = fileInput.closest('.item-card');
        if (itemCard) {
            const fileLabel = itemCard.querySelector('.file-upload-label');
            if (fileLabel) {
                fileLabel.style.color = '';
                fileLabel.textContent = `Téléverser le dessin (max 3 fichiers):`;
            }
        }
        if (fileList) {
            fileList.innerHTML = '';
        }
        validateAllFiles();
        return;
    }

    if (files.length > 3) {
        alert('Vous pouvez joindre un maximum de 3 fichiers par pièce.');
        fileInput.value = '';
        if (fileList) {
            fileList.innerHTML = '';
        }
        return;
    }

    const allowedTypes = ['.dwg', '.dxf', '.pdf', '.png', '.jpg', '.jpeg', '.dgn', '.svg', '.step', '.stp', '.iges', '.igs'];
    const invalidFiles = [];

    for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
        if (!allowedTypes.includes(fileExtension)) {
            invalidFiles.push(file.name);
        }
    }

    if (invalidFiles.length > 0) {
        alert(`Ce format n’est pas accepté : ${invalidFiles.join(', ')}. Formats acceptés : DWG, DXF, PDF, PNG, JPG, DGN, SVG, STEP, STP, IGES, IGS.`);
        fileInput.value = '';
        if (fileList) {
            fileList.innerHTML = '';
        }
        return;
    }

    console.log('File upload:', {
        itemIndex: itemIndex,
        filesCount: files.length,
        files: Array.from(files).map(file => ({
            name: file.name,
            size: file.size,
            type: file.type,
            lastModified: file.lastModified
        }))
    });

    const itemCard = fileInput.closest('.item-card');
    if (itemCard) {
        const fileLabel = itemCard.querySelector('.file-upload-label');
        if (fileLabel) {
            fileLabel.style.color = 'var(--color-success)';
            fileLabel.textContent = `Téléverser le dessin (max 3 fichiers): ✓ ${files.length} fichier(s) sélectionné(s)`;
        }
    }

    if (fileList) {
        fileList.innerHTML = '';
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const fileItem = document.createElement('div');
            fileItem.className = 'file-item';
            fileItem.innerHTML = `
                <span class="file-name">${file.name}</span>
                <span class="file-size">(${formatFileSize(file.size)})</span>
                <button type="button" class="remove-file" onclick="removeFile(${itemIndex}, ${i})">×</button>
            `;
            fileList.appendChild(fileItem);
        }
    }

    validateAllFiles();
}

function removeFile(itemIndex, fileIndex) {
    const fileInput = document.getElementById(`file-${itemIndex}`);
    const files = Array.from(fileInput.files);

    files.splice(fileIndex, 1);

    const dt = new DataTransfer();
    files.forEach(file => dt.items.add(file));
    fileInput.files = dt.files;

    const event = new Event('change', {
        bubbles: true
    });
    fileInput.dispatchEvent(event);
}

function formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

function validateAllFiles() {
    const missingFiles = [];
    orderItems.forEach((item, index) => {
        if (item.dessinFait) {
            const fileInput = document.getElementById(`file-${index}`);
            if (!fileInput || !fileInput.files || fileInput.files.length === 0) {
                missingFiles.push(drawingItemLabel(item, index));
            }
        }
    });

    const errorMessage = DOM.get('errorMessage');
    if (errorMessage) {
        if (missingFiles.length > 0) {
            errorMessage.textContent = missingDrawingsMessage(missingFiles);
            errorMessage.classList.remove('hidden');
        } else {
            errorMessage.classList.add('hidden');
        }
    }
}

function downloadPDF() {
    const btn = document.querySelector('.download-btn');
    const element = document.getElementById('orderSummary');
    const resultPrice = document.querySelector('.result-price');
    const today = new Date().toISOString().split('T')[0];
    let originalText = btn ? btn.innerHTML : '';

    if (!element) {
        console.error('Order summary element not found');
        return;
    }

    const opt = {
        margin: 0.5,
        filename: 'resume-commande.pdf',
        image: {
            type: 'jpeg',
            quality: 0.98
        },
        html2canvas: {
            scale: 2,
            useCORS: true,
            letterRendering: true,
            scrollY: 0,
        },
        jsPDF: {
            unit: 'in',
            format: 'letter',
            orientation: 'portrait',
        },
    };

    if (btn) {
        btn.innerHTML = '⏳ Génération...';
        btn.disabled = true;
    }

    const clone = element.cloneNode(true);

    const buttonsToHide = clone.querySelectorAll('.close-btn, .modifier-btn');
    buttonsToHide.forEach((b) => (b.style.display = 'none'));

    clone.style.background = '#2b698d';
    clone.style.boxShadow = 'none';
    clone.style.padding = '20px';
    clone.style.maxHeight = 'none';
    clone.style.overflow = 'visible';
    clone.style.height = 'auto';

    if (resultPrice) {
        clone.appendChild(resultPrice.cloneNode(true));
    }

    const dateElement = document.createElement('p');
    dateElement.textContent = `Date : ${today}`;
    dateElement.style.textAlign = 'right';
    dateElement.style.fontSize = '12px';
    dateElement.style.color = 'black';
    dateElement.style.marginBottom = '10px';
    clone.prepend(dateElement);

    html2pdf()
        .set(opt)
        .from(clone)
        .save()
        .then(() => {
            if (btn) {
                btn.innerHTML = originalText;
                btn.disabled = false;
            }
        })
        .catch((error) => {
            console.error('PDF generation failed:', error);
            if (btn) {
                btn.innerHTML = '❌ Erreur';
                setTimeout(() => {
                    btn.innerHTML = originalText;
                    btn.disabled = false;
                }, 2000);
            }
        });
}

function openEstimatorWithMaterial(materialApiName) {
    const materielSelect = DOM.get('materiel');
    const drainForm = DOM.get('drainForm');

    const openForm = () => {
        showForm();
    };

    const applyMaterial = () => {
        const target = (materialApiName || '').trim();
        if (!target || !materielSelect) {
            return false;
        }

        const normalizedTarget = normalizeMaterialName(target);
        let found = null;

        for (const opt of materielSelect.options) {
            if (!opt.value) continue;
            const normalizedLabel = normalizeMaterialName(opt.textContent || '');
            if (opt.value === target || normalizeMaterialName(opt.value) === normalizedTarget || normalizedLabel === normalizedTarget) {
                found = opt.value;
                break;
            }
        }

        if (!found) {
            return false;
        }

        materielSelect.value = found;
        materielSelect.dispatchEvent(new Event('change', {
            bubbles: true
        }));
        return true;
    };

    const waitForMaterials = () =>
        new Promise((resolve) => {
            if (!materielSelect) {
                resolve();
                return;
            }
            if (materielSelect.options.length > 1) {
                resolve();
                return;
            }
            let attempts = 0;
            const tick = () => {
                if (materielSelect.options.length > 1 || ++attempts > 60) {
                    resolve();
                    return;
                }
                setTimeout(tick, 100);
            };
            tick();
        });

    return waitForMaterials().then(() => {
        openForm();
        const applied = applyMaterial();
        document.getElementById('estimateur-content')?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
        return applied;
    });
}

window.openEstimatorWithMaterial = openEstimatorWithMaterial;

document.addEventListener('DOMContentLoaded', function() {
    DOM.init();

    initializeMaterials().then(function() {
        const materialParam = new URLSearchParams(window.location.search).get('material');
        if (materialParam) {
            openEstimatorWithMaterial(materialParam);
        }
    });
    updateOrderSummary();
    setupContactFormValidation();

    document.addEventListener('estimateur:start', function(e) {
        const material = e.detail && e.detail.material;
        openEstimatorWithMaterial(material);
    });

    const materielSelect = DOM.get('materiel');
    if (materielSelect) {
        materielSelect.addEventListener('change', function() {
            const rawValue = this.value;

            if (!rawValue) {
                clearMaterialOptions();
                return;
            }

            const cleanValue = normalizeMaterialName(rawValue);
            const selectedMaterialConfig = materialConfigs[cleanValue];

            if (selectedMaterialConfig) {
                updateMaterialOptions(selectedMaterialConfig);
            }
        });
    }

    document.addEventListener('click', function(e) {
        if (e.target.closest('#gradeOptions .option-btn')) {
            const button = e.target.closest('.option-btn');
            if (button.disabled) return;

            document.querySelectorAll('#gradeOptions .option-btn').forEach(btn => {
                btn.classList.remove('selected');
            });

            button.classList.add('selected');

            const gradeInput = DOM.get('grade');
            if (gradeInput) {
                gradeInput.value = button.dataset.grade;
            }

            calculateDynamicPrice();
        }

        if (e.target.closest('#finitionOptions .option-btn')) {
            const button = e.target.closest('.option-btn');
            if (button.disabled) return;

            document.querySelectorAll('#finitionOptions .option-btn').forEach(btn => {
                btn.classList.remove('selected');
            });

            button.classList.add('selected');

            const finitionInput = DOM.get('finition');
            if (finitionInput) {
                finitionInput.value = button.dataset.finition;
            }

            calculateDynamicPrice();
        }
    });

    const drainForm = DOM.get('drainForm');
    if (drainForm) {
        drainForm.addEventListener('submit', function(e) {
            e.preventDefault();
            calculatePrice();
        });
    }

    const contactForm = DOM.get('contactForm');
    if (contactForm) {
        contactForm.addEventListener('submit', async function(e) {
            e.preventDefault();
            const errorMessage = DOM.get('errorMessage');
            const isValid = validateContactForm();
            if (!isValid) {
                if (errorMessage) {
                    errorMessage.textContent = 'Certains champs sont incomplets ou incorrects. Vérifiez le formulaire, puis réessayez.';
                    errorMessage.classList.remove('hidden');
                    errorMessage.scrollIntoView({
                        behavior: 'smooth'
                    });
                }
                return;
            }

            if (errorMessage) errorMessage.classList.add('hidden');

            const formData = new FormData(contactForm);
            const data = Object.fromEntries(formData);
            data.telephone = formatPhoneNumber(data.telephone);

            const requiredFields = ['firstName', 'lastName', 'email', 'telephone', 'streetAddress', 'city', 'state', 'zipCode', 'country'];
            const missingFields = requiredFields.filter(field => !data[field] || data[field].trim() === '');

            if (missingFields.length > 0) {
                if (errorMessage) {
                    errorMessage.classList.remove('hidden');
                    errorMessage.scrollIntoView({
                        behavior: 'smooth'
                    });
                }
                return;
            }

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(data.email)) {
                if (errorMessage) {
                    errorMessage.textContent = 'Entrez une adresse courriel valide (ex. : nom@entreprise.com).';
                    errorMessage.classList.remove('hidden');
                    errorMessage.scrollIntoView({
                        behavior: 'smooth'
                    });
                }
                return;
            }

            const multipartData = collectAndPrepareData(data);
            const submitButton = contactForm.querySelector('button[type="submit"]');

            if (submitButton) {
                submitButton.innerHTML = 'Envoi en cours...';
                submitButton.disabled = true;
            }

            toggleLoading(true);

            try {
                await sendToAPI(multipartData);
                toggleLoading(false);
                if (submitButton) {
                    submitButton.innerHTML = 'C\'est envoyé ! Nous vous reviendrons bientôt.';
                }
            } catch (err) {
                toggleLoading(false);
                if (submitButton) {
                    submitButton.innerHTML = 'Envoyer ma demande';
                    submitButton.disabled = false;
                }
                if (errorMessage) {
                    errorMessage.textContent = 'Impossible d’envoyer la soumission pour le moment. Réessayez dans quelques instants.';
                    errorMessage.classList.remove('hidden');
                    errorMessage.scrollIntoView({
                        behavior: 'smooth'
                    });
                }
            }

        });
    }

    setupAllEventListeners();

});

function canCalculateDynamicPrice() {
    const requiredFields = {
        materiel: DOM.get('materiel')?.value,
        grade: DOM.get('grade')?.value,
        finition: DOM.get('finition')?.value,
        epaisseur: DOM.get('epaisseur')?.value,
        largeur: DOM.get('largeur')?.value,
        longueur: DOM.get('longueur')?.value,
        quantite: DOM.get('quantite')?.value
    };

    for (const [field, value] of Object.entries(requiredFields)) {
        if (!value || value === '' || (field === 'quantite' && parseInt(value) <= 0)) {
            return false;
        }
    }

    const largeur = parseDimension(requiredFields.largeur);
    const longueur = parseDimension(requiredFields.longueur);
    const epaisseur = parseFloat(requiredFields.epaisseur);

    if (!Number.isFinite(largeur) || !Number.isFinite(longueur) || !Number.isFinite(epaisseur)) {
        return false;
    }

    if (largeur <= 0 || longueur <= 0 || epaisseur <= 0) {
        return false;
    }

    return true;
}

function updateButtonWithPrice(price = null, isLoading = false, prixParPiece) {
    const button = DOM.get('prixTotalSpan');
    const buttonContainer = DOM.get('envoyerFormulaireBtn');
    const span = document.createElement('span');
    span.classList.add('prixParPiece');
    const existingSpan = document.querySelector('.prixParPiece');

    if (existingSpan) {
        existingSpan.remove();
    }
    if (!button) return;
    console.log("PRIX PAR PIECE : " + prixParPiece);

    const baseText = currentEditingIndex >= 0 ? "Modifier la pièce" : "Ajouter cette pièce";

    if (isLoading) {
        button.textContent = `${baseText} - Calcul...`;
        button.disabled = true;
    } else if (price !== null) {
        button.textContent = `${baseText} - ${price}`;
        button.disabled = false;
        if (prixParPiece && !isNaN(prixParPiece) && prixParPiece !== 0) {
            buttonContainer.appendChild(span);
            span.innerText = 'Prix par pièce - ' + prixParPiece.toString() + "$";
        }

    } else {
        button.textContent = baseText;
        button.disabled = false;
    }
}

function calculateDynamicPrice() {
    if (dynamicPriceTimeout) {
        clearTimeout(dynamicPriceTimeout);
    }

    dynamicPriceTimeout = setTimeout(async () => {
        await performDynamicPriceCalculation();
    }, 300);
}

async function performDynamicPriceCalculation() {
    if (isCalculatingDynamicPrice) {
        return;
    }

    if (!canCalculateDynamicPrice()) {
        updateButtonWithPrice(null);
        clearAPIErrors();
        return;
    }

    isCalculatingDynamicPrice = true;

    try {
        updateButtonWithPrice(null, true);
        clearAPIErrors();

        const form = DOM.get('drainForm');
        if (!form) throw new Error('Form not found');

        const formData = new FormData(form);
        const item = {
            "quantite": Number(formData.get('quantite')) || 1,
            "materiel": formData.get('materiel'),
            "grade": DOM.get('grade')?.value || '',
            "epaisseur": Number(formData.get('epaisseur')),
            "finition": DOM.get('finition')?.value || '',
            "uniteDeMesure": CONFIG.DEFAULT_UNIT,
            "largeur": toInches(formData.get('largeur')),
            "longueur": toInches(formData.get('longueur')),
            "nombreTroue": Number(formData.get('nombreTroue')) || 0,
            "diametreTroue": toInches(formData.get('diametreTroue')) || 0,
            "autrePerimetre": toInches(formData.get('autrePerimetre')) || 0,
            "nombrePlie": Number(formData.get('nombrePlie')) || 0,
            "dessinFait": formData.get('dessinFait') === 'on',
            "itemIdentifiant": formData.get('numeroPiece')
        };

        const payload = {
            items: [item]
        };
        console.log(payload)
        const response = await retry(() =>
            fetchWithTimeout(`${CONFIG.BASE_URL}/commande/estimation`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload),
            })
        );

        if (!response.ok) {
            let errorData;

            try {
                errorData = await response.json();
            } catch {
                throw new Error(`HTTP error ${response.status}`);
            }

            if (errorData.exception) {
                showAPIError(errorData.exception, errorData.message, false);
            }

            const apiError = new Error(errorData.message || "Erreur inconnue");
            apiError.exception = errorData.exception;
            throw apiError;
        }

        const data = await response.json();
        const result = returnPerPlaque(data);
        const price = result.price;

        const quantiteInt = parseInt(Number(formData.get('quantite')));
        const formattedPrice = parseFloat(price.replace(/[^\d,.-]/g, '').replace(',', '.'));
        let prixParPiece = 0;
        if (quantiteInt !== 1) {
            let equation = formattedPrice / quantiteInt
            prixParPiece = equation.toFixed(2);
        } else {
            prixParPiece = 0;
        }

        updateButtonWithPrice(price, false, prixParPiece);

    } catch (error) {
        console.error('Dynamic price calculation failed:', error);
        updateButtonWithPrice(null);
    } finally {
        isCalculatingDynamicPrice = false;
    }
}

function collectAndPrepareData(contactData) {
    console.log('=== COLLECTING DATA FOR MULTIPART/FORM-DATA ===');

    const sameAsShippingCheckbox = document.getElementById('sameAsShipping');
    const sameAsShipping = sameAsShippingCheckbox ? sameAsShippingCheckbox.checked : true;

    const customer = {
        nom: `${contactData.firstName} ${contactData.lastName}`.trim(),
        nomEntreprise: contactData.company || "",
        courriel: contactData.email,
        telephone: contactData.telephone,
        adresseFacturation: String(!sameAsShipping),
        localisationPersonnelle: {
            adresse: contactData.streetAddress,
            adresseLigne2: contactData.addressLine2 || "",
            ville: contactData.city,
            province: contactData.state,
            codePostal: contactData.zipCode,
            pays: contactData.country
        },
        localisationFacturation: {
            adresse: sameAsShipping ? contactData.streetAddress : (contactData.billingStreetAddress || ""),
            adresseLigne2: sameAsShipping ? (contactData.addressLine2 || "") : (contactData.billingAddressLine2 || ""),
            ville: sameAsShipping ? contactData.city : (contactData.billingCity || ""),
            province: sameAsShipping ? contactData.state : (contactData.billingState || ""),
            codePostal: sameAsShipping ? contactData.zipCode : (contactData.billingZipCode || ""),
            pays: sameAsShipping ? contactData.country : (contactData.billingCountry || "")
        },
        notes: contactData.deliveryNotes || ""
    };

    const customerJson = JSON.stringify(customer);

    const transformedOrderItems = {
        items: orderItems.map(item => itemToApiUnits(item))
    };
    const commandeJson = JSON.stringify(transformedOrderItems);

    const drawingFiles = [];
    orderItems.forEach((item, index) => {
        const fileInput = document.getElementById(`file-${index}`);
        if (fileInput && fileInput.files && fileInput.files.length > 0) {
            console.log(`✓ Found ${fileInput.files.length} file(s) for item ${index}:`,
                Array.from(fileInput.files).map(f => f.name));

            Array.from(fileInput.files).forEach(file => {
                drawingFiles.push(file);
            });
        } else {
            console.log(`✗ No files found for item ${index}`);
        }
    });

    console.log(`📎 Total files collected: ${drawingFiles.length}`);

    const multipartData = new FormData();
    multipartData.append("customer", new Blob([customerJson], {
        type: "application/json"
    }), "customer.json");
    multipartData.append("commande", new Blob([commandeJson], {
        type: "application/json"
    }), "commande.json");

    if (drawingFiles.length > 0) {
        drawingFiles.forEach((file, idx) => {
            console.log(`📄 Appending file ${idx + 1}/${drawingFiles.length}: ${file.name} (${file.size} bytes)`);
            multipartData.append("drawing", file, file.name);
        });
    } else {
        console.log('⚠️ No files to append');
    }

    console.log('=== MULTIPART/FORM-DATA PREPARED ===');
    console.log('Customer JSON:', customerJson);
    console.log('Commande JSON:', commandeJson);
    console.log('Files count:', drawingFiles.length);

    for (let [key, value] of multipartData.entries()) {
        if (value instanceof File) {
            console.log(`[FILE] Key: ${key}`, {
                name: value.name,
                size: value.size,
                type: value.type
            });
        } else if (value instanceof Blob) {
            const reader = new FileReader();
            reader.onload = function(event) {
                console.log(`[JSON] Key: ${key}`, event.target.result);
            };
            reader.readAsText(value);
        }
    }

    return multipartData;
}

async function sendToAPI(multipartData) {

    try {
        const response = await fetch("https://api.linkcofab.com/commande/soumission", {
            method: "POST",
            body: multipartData
        });

        if (!response.ok) {
            throw new Error(`❌ API error: ${response.status} ${response.statusText}`);
        }

        const result = await response.json().catch(() => null);
        console.log("✅ API response:", result || "No JSON response");
        alert("Soumission envoyée avec succès !");
        resetAllData();
        return result;
    } catch (error) {
        console.error("⚠️ Error sending to API:", error);
        throw error;
    }
}

function resetAllData() {
    orderItems = [];
    currentEditingIndex = -1;
    currentThicknesses = [];

    const drainForm = DOM.get('drainForm');
    if (drainForm && typeof drainForm.reset === 'function') {
        drainForm.reset();
    }

    const contactForm = DOM.get('contactForm');
    if (contactForm && typeof contactForm.reset === 'function') {
        contactForm.reset();
    }

    const materialSelect = DOM.get('materiel');
    if (materialSelect?.options.length > 0) {
        materialSelect.selectedIndex = 0;
    }

    clearMaterialOptions();

    resetCustomControls();

    currentStep = 1;

    clearGrid();

    showList();

    updateOrderSummary();

    const errorMessage = DOM.get('errorMessage');
    if (errorMessage) {
        errorMessage.classList.add('hidden');
    }

    console.log('✅ All data reset successfully');
}

const VALIDATION_PATTERNS = {
    email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    postalCode: /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/
};

const ERROR_MESSAGES = {
    required: 'Ce champ est requis.',
    email: 'Entrez une adresse courriel valide (ex. : nom@entreprise.com).',
    phone: 'Entrez un numéro de téléphone à 10 chiffres (ex. : 514-555-1234).',
    postalCode: 'Entrez un code postal canadien valide (ex. : H2X 1Y7).',
    postalCodeBilling: 'Entrez un code postal de facturation canadien valide (ex. : H2X 1Y7).'
};

function normalizePhoneDigits(value) {
    const digits = String(value || '').replace(/\D/g, '');
    const normalized = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
    return normalized.slice(0, 10);
}

function isValidPhoneNumber(value) {
    return /^\d{10}$/.test(normalizePhoneDigits(value));
}

function formatPhoneNumber(value) {
    const digits = normalizePhoneDigits(value);
    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
}

function showFieldError(field, message) {
    if (!field) return;

    field.classList.add('error');

    const formGroup = field.closest('.form-group') || field.closest('.dimensions-group');
    if (!formGroup) {
        const existingError = field.parentElement.querySelector('.field-error');
        if (existingError) existingError.remove();

        const errorSpan = document.createElement('span');
        errorSpan.className = 'field-error';
        errorSpan.textContent = message;
        field.parentElement.appendChild(errorSpan);
        return;
    }

    const existingError = formGroup.querySelector('.field-error');
    if (existingError) {
        existingError.remove();
    }

    const errorSpan = document.createElement('span');
    errorSpan.className = 'field-error';
    errorSpan.textContent = message;
    formGroup.appendChild(errorSpan);
}

function clearFieldError(field) {
    if (!field) return;

    field.classList.remove('error');

    const formGroup = field.closest('.form-group') || field.closest('.dimensions-group');
    if (formGroup) {
        const errorSpan = formGroup.querySelector('.field-error');
        if (errorSpan) {
            errorSpan.remove();
        }
    } else {
        const errorSpan = field.parentElement.querySelector('.field-error');
        if (errorSpan) {
            errorSpan.remove();
        }
    }
}

function validateField(field, validationType = 'required') {
    if (!field) return true;

    const value = field.value.trim();

    if (field.hasAttribute('required') && !value) {
        showFieldError(field, ERROR_MESSAGES.required);
        return false;
    }

    if (!value && !field.hasAttribute('required')) {
        clearFieldError(field);
        return true;
    }

    let isValid = true;
    let errorMessage = '';

    switch (validationType) {
        case 'email':
            isValid = VALIDATION_PATTERNS.email.test(value);
            errorMessage = ERROR_MESSAGES.email;
            break;
        case 'phone':
            isValid = isValidPhoneNumber(value);
            if (isValid) {
                field.value = formatPhoneNumber(value);
            }
            errorMessage = ERROR_MESSAGES.phone;
            break;
        case 'postalCode':
            isValid = VALIDATION_PATTERNS.postalCode.test(value);
            errorMessage = ERROR_MESSAGES.postalCode;
            break;
        case 'postalCodeBilling':
            isValid = VALIDATION_PATTERNS.postalCode.test(value);
            errorMessage = ERROR_MESSAGES.postalCodeBilling;
            break;
        default:
            isValid = value.length > 0;
            errorMessage = ERROR_MESSAGES.required;
    }

    if (isValid) {
        clearFieldError(field);
    } else {
        showFieldError(field, errorMessage);
    }

    return isValid;
}

function validateContactForm() {
    let isValid = true;

    const shippingFields = [{
            id: 'firstName',
            type: 'required'
        },
        {
            id: 'lastName',
            type: 'required'
        },
        {
            id: 'email',
            type: 'email'
        },
        {
            id: 'telephone',
            type: 'phone'
        },
        {
            id: 'streetAddress',
            type: 'required'
        },
        {
            id: 'city',
            type: 'required'
        },
        {
            id: 'state',
            type: 'required'
        },
        {
            id: 'zipCode',
            type: 'postalCode'
        },
        {
            id: 'country',
            type: 'required'
        }
    ];

    shippingFields.forEach(fieldConfig => {
        const field = document.getElementById(fieldConfig.id);
        if (field && !validateField(field, fieldConfig.type)) {
            isValid = false;
        }
    });

    const sameAsShipping = document.getElementById('sameAsShipping');
    if (sameAsShipping && !sameAsShipping.checked) {
        const billingFields = [{
                id: 'billingStreetAddress',
                type: 'required'
            },
            {
                id: 'billingCity',
                type: 'required'
            },
            {
                id: 'billingState',
                type: 'required'
            },
            {
                id: 'billingZipCode',
                type: 'postalCodeBilling'
            },
            {
                id: 'billingCountry',
                type: 'required'
            }
        ];

        billingFields.forEach(fieldConfig => {
            const field = document.getElementById(fieldConfig.id);
            if (field && !validateField(field, fieldConfig.type)) {
                isValid = false;
            }
        });
    }

    return isValid;
}

function setupContactFormValidation() {
    const emailField = document.getElementById('email');
    if (emailField) {
        emailField.addEventListener('blur', () => validateField(emailField, 'email'));
        emailField.addEventListener('input', () => {
            if (emailField.classList.contains('error')) {
                validateField(emailField, 'email');
            }
        });
    }

const phoneField = document.getElementById('telephone');
    if (phoneField) {
        phoneField.addEventListener('blur', () => {
            phoneField.value = formatPhoneNumber(phoneField.value);
            validateField(phoneField, 'phone');
        });
        phoneField.addEventListener('input', () => {
            phoneField.value = formatPhoneNumber(phoneField.value);
            if (phoneField.classList.contains('error')) {
                validateField(phoneField, 'phone');
            }
        });
    }

    const postalCodeField = document.getElementById('zipCode');
    if (postalCodeField) {
        postalCodeField.addEventListener('blur', () => validateField(postalCodeField, 'postalCode'));
        postalCodeField.addEventListener('input', () => {
            if (postalCodeField.classList.contains('error')) {
                validateField(postalCodeField, 'postalCode');
            }
        });
    }

    const billingPostalCodeField = document.getElementById('billingZipCode');
    if (billingPostalCodeField) {
        billingPostalCodeField.addEventListener('blur', () => validateField(billingPostalCodeField, 'postalCodeBilling'));
        billingPostalCodeField.addEventListener('input', () => {
            if (billingPostalCodeField.classList.contains('error')) {
                validateField(billingPostalCodeField, 'postalCodeBilling');
            }
        });
    }

    const requiredFields = ['firstName', 'lastName', 'streetAddress', 'city', 'state', 'country'];
    requiredFields.forEach(fieldId => {
        const field = document.getElementById(fieldId);
        if (field) {
            field.addEventListener('blur', () => validateField(field, 'required'));
            field.addEventListener('input', () => {
                if (field.classList.contains('error')) {
                    validateField(field, 'required');
                }
            });
        }
    });

    const billingRequiredFields = ['billingStreetAddress', 'billingCity', 'billingState', 'billingCountry'];
    billingRequiredFields.forEach(fieldId => {
        const field = document.getElementById(fieldId);
        if (field) {
            field.addEventListener('blur', () => {
                const sameAsShipping = document.getElementById('sameAsShipping');
                if (sameAsShipping && !sameAsShipping.checked) {
                    validateField(field, 'required');
                }
            });
            field.addEventListener('input', () => {
                if (field.classList.contains('error')) {
                    const sameAsShipping = document.getElementById('sameAsShipping');
                    if (sameAsShipping && !sameAsShipping.checked) {
                        validateField(field, 'required');
                    }
                }
            });
        }
    });
}

document.addEventListener('DOMContentLoaded', function() {
    const sameAsShipping = document.getElementById('sameAsShipping');
    const billingFields = document.getElementById('billingAddressFields');
    if (!sameAsShipping || !billingFields) return;

    function toggleBillingFields() {
        if (sameAsShipping.checked) {
            billingFields.style.display = 'none';
            billingFields.querySelectorAll('input').forEach(input => input.value = '');
        } else {
            billingFields.style.display = '';
        }
    }

    sameAsShipping.addEventListener('change', toggleBillingFields);
    toggleBillingFields();
});

(function initInfoPopup() {
    const popup = document.getElementById('infoPopup');
    const backdrop = document.getElementById('infoPopupBackdrop');
    const trigger = document.getElementById('openInfoPopup');
    if (!popup || !backdrop || !trigger) return;
    const closeBtn = popup.querySelector('.info-popup-close');

    function openPopup() {
        backdrop.classList.add('active');
        popup.classList.add('active');
        document.body.style.overflow = 'hidden';
    }

    function closePopup() {
        backdrop.classList.remove('active');
        popup.classList.remove('active');
        document.body.style.overflow = '';
    }

    trigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        openPopup();
    });

    trigger.addEventListener('mouseenter', openPopup);
    trigger.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            openPopup();
        }
    });
    trigger.setAttribute('tabindex', '0');
    trigger.setAttribute('role', 'button');

    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    backdrop.addEventListener('click', closePopup);

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && popup.classList.contains('active')) {
            closePopup();
        }
    });
})();

(function initHelpTips() {
    const tips = document.querySelectorAll('.section-estimateur .help');
    if (!tips.length) return;

    const bubble = document.createElement('div');
    bubble.className = 'est-help-tip';
    bubble.id = 'estHelpTip';
    bubble.setAttribute('role', 'tooltip');
    document.body.appendChild(bubble);

    let active = null;
    let pinned = false;
    let hideTimer = 0;

    function helpText(el) {
        return el.getAttribute('data-help') || el.getAttribute('title') || '';
    }

    function place(el) {
        const gap = 8;
        const rect = el.getBoundingClientRect();
        const width = bubble.offsetWidth;
        const height = bubble.offsetHeight;
        let top = rect.bottom + gap;
        let left = rect.left + rect.width / 2 - width / 2;

        left = Math.max(12, Math.min(left, window.innerWidth - width - 12));
        if (top + height > window.innerHeight - 12) {
            top = Math.max(12, rect.top - height - gap);
        }

        bubble.style.top = top + 'px';
        bubble.style.left = left + 'px';
    }

    function show(el) {
        const text = helpText(el);
        if (!text) return;
        window.clearTimeout(hideTimer);
        if (el.hasAttribute('title')) {
            el.setAttribute('data-help', el.getAttribute('title'));
            el.removeAttribute('title');
        }
        bubble.textContent = text;
        bubble.classList.add('is-visible');
        active = el;
        place(el);
    }

    function hide() {
        if (pinned) return;
        bubble.classList.remove('is-visible');
        active = null;
    }

    function scheduleHide() {
        window.clearTimeout(hideTimer);
        hideTimer = window.setTimeout(hide, 140);
    }

    tips.forEach((el) => {
        if (el.hasAttribute('title')) {
            el.setAttribute('data-help', el.getAttribute('title'));
            el.removeAttribute('title');
        }
        el.setAttribute('tabindex', '0');
        el.setAttribute('role', 'button');
        el.setAttribute('aria-label', 'Plus d’information');

        el.addEventListener('mouseenter', () => show(el));
        el.addEventListener('mouseleave', scheduleHide);
        el.addEventListener('focus', () => show(el));
        el.addEventListener('blur', () => {
            pinned = false;
            scheduleHide();
        });
        el.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (active === el && pinned) {
                pinned = false;
                hide();
                return;
            }
            pinned = true;
            show(el);
        });
        el.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                el.click();
            }
        });
    });

    bubble.addEventListener('mouseenter', () => window.clearTimeout(hideTimer));
    bubble.addEventListener('mouseleave', scheduleHide);

    document.addEventListener('click', (e) => {
        if (e.target.closest('.help') || e.target.closest('#estHelpTip')) return;
        pinned = false;
        hide();
    });

    window.addEventListener('scroll', () => {
        if (active) place(active);
    }, true);
})();

(function initAvisModal() {
    const modal = document.getElementById('avisModal');
    if (!modal) return;
    const avisForm = document.getElementById('avisForm');
    const avisThanks = document.getElementById('avisThanks');
    const avisFoot = document.getElementById('avisFoot');
    const stars = Array.from(document.querySelectorAll('#stars button'));
    const avisAutre = document.getElementById('avisAutre');
    const avisAutreWrap = document.getElementById('avisAutreWrap');
    let rating = 0;

    function paintStars(n) {
        stars.forEach((s, i) => s.classList.toggle('on', i < n));
    }

    function openModal() {
        modal.classList.add('open');
        document.body.style.overflow = 'hidden';
    }

    function closeModal() {
        modal.classList.remove('open');
        document.body.style.overflow = '';
        setTimeout(resetAvis, 200);
    }

    function resetAvis() {
        if (avisForm) avisForm.style.display = '';
        if (avisThanks) avisThanks.classList.remove('show');
        if (avisFoot) avisFoot.style.display = '';
        rating = 0;
        paintStars(0);
        modal.querySelectorAll('input[type=checkbox]').forEach((c) => (c.checked = false));
        const ta = modal.querySelector('textarea');
        if (ta) ta.value = '';
        if (avisAutreWrap) avisAutreWrap.classList.remove('show');
        const ai = document.getElementById('avisAutreInput');
        if (ai) ai.value = '';
    }

    const openAvisBtn = document.getElementById('openAvis');
    if (openAvisBtn) openAvisBtn.addEventListener('click', openModal);
    modal.querySelectorAll('[data-close]').forEach((el) => el.addEventListener('click', closeModal));
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.classList.contains('open')) closeModal();
    });

    if (avisAutre && avisAutreWrap) {
        avisAutre.addEventListener('change', () => {
            avisAutreWrap.classList.toggle('show', avisAutre.checked);
            if (avisAutre.checked) setTimeout(() => document.getElementById('avisAutreInput')?.focus(), 140);
        });
    }

    stars.forEach((s) => {
        s.addEventListener('mouseenter', () => paintStars(+s.dataset.v));
        s.addEventListener('click', () => {
            rating = +s.dataset.v;
            paintStars(rating);
        });
    });
    const starsWrap = document.getElementById('stars');
    if (starsWrap) starsWrap.addEventListener('mouseleave', () => paintStars(rating));

    const submitAvis = document.getElementById('submitAvis');
    if (submitAvis) submitAvis.addEventListener('click', () => {
        if (avisForm) avisForm.style.display = 'none';
        if (avisFoot) avisFoot.style.display = 'none';
        if (avisThanks) avisThanks.classList.add('show');
        setTimeout(closeModal, 1900);
    });
})();

['largeur', 'longueur'].forEach((id) => {
    const input = document.getElementById(id);
    if (!input) return;
    input.addEventListener('input', function() {
        sanitizeDimensionField(this);
    });
});

/* ===== Capture de lead estimateur (test Koa, 2026-10-24) =====
   À ajouter à la fin de assets/estimateur.js (avant ou après le bloc final,
   au niveau racine du script : le module utilise orderItems et formatPrice,
   déjà définis dans ce fichier).
   Avant la mise en ligne, remplacer les 4 constantes LEAD_FORM_* par les
   valeurs du formulaire Google "Leads estimateur - réponses" (voir spec.md).
   Aucune chaîne ne contient d'apostrophe non échappée : les textes français
   utilisent des guillemets doubles ou des apostrophes typographiques. */
(function () {
    var LEAD_FORM_URL = "https://docs.google.com/forms/d/e/1FAIpQLScr17FEfIa9vB6UlzaQTYcp8b4f8LgkPFD_qcbAoMzSRYKNew/formResponse";
    var LEAD_ENTRY_EMAIL = "entry.1764312444";
    var LEAD_ENTRY_DETAIL = "entry.576064746";
    var LEAD_ENTRY_TOTAL = "entry.256787395";

    function leadTotal() {
        var total = 0;
        (window.orderItems || orderItems || []).forEach(function (item) {
            var p = parseFloat(((item.price || "") + "").replace(",", ".")) || 0;
            total += p;
        });
        var minimum = (typeof MINIMUM_COMMANDE !== "undefined") ? MINIMUM_COMMANDE : 70;
        if (total > 0 && total < minimum) total = minimum;
        return total;
    }

    function leadDetail() {
        var items = (window.orderItems || orderItems || []);
        var lines = items.map(function (item, i) {
            return [
                "Pièce " + (item.numeroPiece || (i + 1)),
                "quantité " + item.quantite,
                "matériau " + item.materiel,
                "grade " + item.grade,
                "finition " + item.finition,
                "dimensions " + item.largeur + " x " + item.longueur + " " + (item.uniteDeMesure || "po"),
                "épaisseur " + item.epaisseur,
                "trous " + item.nombreTroue,
                "plis " + item.nombrePlie,
                "prix " + item.price
            ].join(", ");
        });
        lines.push("Total estimé (avant taxes) : " + formatPrice(leadTotal()));
        return lines.join("\n");
    }

    function leadRefreshVisibility() {
        var block = document.getElementById("leadCapture");
        if (!block) return;
        var items = (window.orderItems || orderItems || []);
        block.hidden = items.length === 0;
    }

    function leadSend() {
        var msg = document.getElementById("leadMsg");
        var emailInput = document.getElementById("leadEmail");
        var trap = document.getElementById("leadSiteWeb");
        if (trap && trap.value) return;
        var email = (emailInput.value || "").trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
            msg.textContent = "Entrez un courriel valide pour recevoir votre estimation.";
            emailInput.focus();
            return;
        }
        var body = new URLSearchParams();
        body.append(LEAD_ENTRY_EMAIL, email);
        body.append(LEAD_ENTRY_DETAIL, leadDetail());
        body.append(LEAD_ENTRY_TOTAL, leadTotal().toFixed(2));
        var btn = document.getElementById("leadSendBtn");
        btn.disabled = true;
        msg.textContent = "Envoi en cours...";
        fetch(LEAD_FORM_URL, {
            method: "POST",
            mode: "no-cors",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: body.toString()
        }).then(function () {
            msg.textContent = "C\u2019est envoyé. Vous recevrez votre estimation par courriel sous peu.";
            btn.textContent = "Estimation demandée";
        }).catch(function () {
            btn.disabled = false;
            msg.textContent = "L\u2019envoi a échoué. Réessayez, ou écrivez-nous à info@soumissionmetal.com.";
        });
    }

    function leadInit() {
        var optIn = document.getElementById("leadOptIn");
        var row = document.getElementById("leadEmailRow");
        var btn = document.getElementById("leadSendBtn");
        if (!optIn || !row || !btn) return;
        optIn.addEventListener("change", function () {
            row.hidden = !optIn.checked;
            if (optIn.checked) {
                var emailInput = document.getElementById("leadEmail");
                if (emailInput) emailInput.focus();
            }
        });
        btn.addEventListener("click", leadSend);
        leadRefreshVisibility();
        var summary = document.getElementById("orderSummary");
        if (summary && window.MutationObserver) {
            new MutationObserver(leadRefreshVisibility).observe(summary, { childList: true, subtree: true });
        }
        setInterval(leadRefreshVisibility, 2000);
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", leadInit);
    } else {
        leadInit();
    }
})();
/* ===== Fin capture de lead estimateur ===== */
